<!-- @format -->

<template>
	<div class="showDiv" :style="{ width: pcProps.width, height: pcProps.height }">
		<div :style="{ width: pcProps.width, height: pcProps.height }" @click="handleClick">
			<img v-if="value !== ''" :src="value" :style="{ width: pcProps.width, height: pcProps.height }" />
			<div v-else>请点击进行签名</div>
		</div>
		<div class="esign-dialog">
			<el-dialog v-model="dialogVisible" :fullscreen="true" destroy-on-close :show-close="false">
				<div class="show-esign">
					<pc-esign @confirm-event="handleGenerate" @cancel-event="handleCancel" />
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { type WidgetConfigType } from '../../types';
	import { PcEsign } from '@/components';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const dialogVisible = ref(false);

	const value = computed({
		get() {
			return props.modelValue || '';
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const handleClick = () => {
		if (!props.disabled) {
			dialogVisible.value = true;
		}
	};

	const handleGenerate = (val) => {
		value.value = val;
		dialogVisible.value = false;
	};

	const handleCancel = () => {
		dialogVisible.value = false;
	};
</script>
<style lang="scss" scoped>
	.showDiv {
		border: 1px solid #ccc;
	}

	.esign-dialog {
		:deep(.el-dialog__header) {
			display: none;
		}
	}
</style>
